module.exports = __webpack_public_path__ + "img/settings.ed701ba6.svg";